import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch, useParams } from "react-router-dom";
// Utils
import { BU_ID, DISTRIBUTION_LISTS, MARKETPLACE, MY_LISTINGS, SELLING, TRADING } from "constants/Routes";
import { useHasFeature, useDistributionListsCount } from "hooks";

import { DistributionLists } from "trading/pages/DistributionLists";
import { SubTab } from "components/Common/Tabs";
import { ViewBuyerListings } from "./Liveweight/ViewBuyerListings";
import { ViewSellerListings } from "./Liveweight/ViewSellerListings";
import { EmptyState, PageContent, Spacer, Header, Tabs, PageHeader } from "components";
import { EmptyStatePage } from "generated/graphql";

const Trading: React.FC = () => {
  const { tradingTabType, tradingSubTabType } = useParams<TradingRootPageParams>();
  const isShowDistributionLists = useHasFeature("SHOW_DISTRIBUTION_LISTS");
  const { data: listsCount } = useDistributionListsCount();
  const [currentSelectedTab, changeCurrentSelectedTab] = useState<number>(0);
  const [currentSelectedSubTab, changeCurrentSelectedSubTab] = useState<number>(0);

  const tradingTabs: SubTab[] = [
    {
      key: 0,
      name: "Buying",
      route: `${TRADING}${MARKETPLACE}`,
    },
    {
      key: 1,
      name: "Selling",
      route: `${TRADING}${MY_LISTINGS}`,
    },
    {
      key: 2,
      name: "Lists",
      route: `${TRADING}${DISTRIBUTION_LISTS}`,
      count: listsCount,
    },
  ];

  const buyingTabs: SubTab[] = [
    {
      key: 0,
      name: "Liveweight",
      route: `${TRADING}${MARKETPLACE}`,
      value: "liveweight",
    },
  ];

  const sellingTabs: SubTab[] = [
    {
      key: 0,
      name: "My Listings",
      route: `${TRADING}${MY_LISTINGS}`,
      value: "my-listings",
    },
    {
      key: 1,
      name: "Deadweight",
      route: `${TRADING}${SELLING}`,
    },
  ];

  useEffect(() => {
    const selectedTabKey: number = tradingTabs.find((item) => item.name.toLowerCase() === tradingTabType)?.key || 0;

    changeCurrentSelectedTab(selectedTabKey);
    if (selectedTabKey < 2) {
      const selectedSubTabKey =
        (selectedTabKey === 0 ? buyingTabs : sellingTabs).find(
          (item) => item.value?.toLowerCase() === tradingSubTabType,
        )?.key || 0;

      changeCurrentSelectedSubTab(selectedSubTabKey);
    }
  }, [
    tradingTabType,
    tradingTabs,
    changeCurrentSelectedTab,
    sellingTabs,
    buyingTabs,
    tradingSubTabType,
    changeCurrentSelectedSubTab,
  ]);

  return (
    <>
      <PageHeader>
        <Header title="Trading" />
        <Tabs tabs={tradingTabs} selectedTab={currentSelectedTab} />
        {currentSelectedTab === 0 && <Tabs grayBackgroundTabs tabs={buyingTabs} selectedTab={currentSelectedSubTab} />}
        {currentSelectedTab === 1 && <Tabs grayBackgroundTabs tabs={sellingTabs} selectedTab={currentSelectedSubTab} />}
      </PageHeader>

      <Switch>
        <Route
          exact
          path={`${BU_ID}${TRADING}${SELLING}`}
          component={() => (
            <PageContent>
              <Spacer baselineHeight={2} />
              <EmptyState page={EmptyStatePage.DeadWeight} />
            </PageContent>
          )}
        />
        {isShowDistributionLists && (
          <Route exact path={`${BU_ID}${TRADING}${DISTRIBUTION_LISTS}`} component={DistributionLists} />
        )}
        <Route exact path={`${BU_ID}${TRADING}${MARKETPLACE}`} component={ViewBuyerListings} />

        <Route exact path={`${BU_ID}${TRADING}${MY_LISTINGS}`} component={ViewSellerListings} />
        <Redirect to={`${BU_ID}${TRADING}${MARKETPLACE}`} />
      </Switch>
    </>
  );
};

export default Trading;
